import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useTransactionsList } from '@/api/rpc/hooks/finance/useTransactions';
import { formatCurrency } from '@erp/shared-utils';

interface FinancialTransactionInlineProps {
  entityType: SystemEntity; // required by registry; type is FINANCIAL_TRANSACTION
  entityId: string;
  className?: string;
}

export function FinancialTransactionInline({
  entityId,
  className,
}: FinancialTransactionInlineProps) {
  const { transactions } = useTransactionsList({});
  const tx = transactions.find((t) => t.id === entityId);

  const amountText = tx
    ? formatCurrency(Number(tx.amount || 0), tx.currency || 'USD')
    : '—';

  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <div className="inline-block">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer', className)}
          >
            <ArrowsLeftRightIcon className="size-3" />
            <span className="font-mono">{amountText}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.FINANCIAL_TRANSACTION}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
